/** Used as references for various `Number` constants. */

// check empty
const isEmpty = (value) => {
  return value === null ||
    value === undefined ||
    value === '' ||
    (Array.isArray(value) && value.length === 0) ||
    (typeof value === 'string' && value.trim() === '') ||
    (typeof value === 'object' && Object.keys(value).length === 0)
}

// check numeric
const isNumeric = (value) => {
  const pattern = /^-?(\s*|\d+)$/
  return pattern.test(value)
}

// check decimal
const isDecimal = (value) => {
  const pattern = /^-?(?:\d*(?:\.\d*)?)?$/
  return pattern.test(value)
}

// check is email
const isEmail = (value) => {
  const pattern = /\S+@\S+\.\S+/
  return pattern.test(value)
}

const isPrice = (value, price_scale) => {
  const price = Number(value)

  if (!isDecimal(value)) return false

  if (!price_scale || price === 0) return true

  if (
    (price_scale < 0 && price < (10 ** Math.abs(price_scale))) ||
    (price_scale === 0 && !Number.isInteger(price))
  ) {
    return false
  }
  return true
}

export {
  isDecimal,
  isEmail,
  isEmpty,
  isNumeric,
  isPrice,
}
